import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import LandingPage from './components/LandingPage';
import Login from './components/Login';
import AuthCallback from './components/AuthCallback';
import AcceptInvitation from './components/AcceptInvitation';
import ProtectedRoute from './components/ProtectedRoute';
import Famlis from './components/Famlis';
import Dashboard from './components/Dashboard';
import Premium from './components/Premium';
import Calendar from './components/Calendar';
import TodoLists from './components/TodoLists';
import SecretsVault from './components/SecretsVault';
import Documents from './components/Documents';
import Appliances from './components/Appliances';
import Vehicles from './components/Vehicles';
import FamilyTree from './components/FamilyTree';
import HealthWellness from './components/HealthWellness';
import Trips from './components/Trips';
import BeliefsAndTraditions from './components/BeliefsAndTraditions';
import CommunityAndGiving from './components/CommunityAndGiving';
import LegacyAndEstate from './components/LegacyAndEstate';
import Pets from './components/Pets';
import RecipeBox from './components/RecipeBox';
import FamilyFinance from './components/FamilyFinance';
import ContactBook from './components/ContactBook';
import EducationLearning from './components/EducationLearning';
import FamilySettings from './components/FamilySettings';
import AboutUs from './components/AboutUs';
import Contact from './components/Contact';
import Blog from './components/Blog';
import PrivacyPolicy from './components/PrivacyPolicy';
import TermsOfService from './components/TermsOfService';
import Security from './components/Security';

function App() {
    return (
        <Router>
            <div className="App">
                <Routes>
                    {/* Public Routes */}
                    <Route path="/" element={<LandingPage />} />
                    <Route path="/login" element={<Login />} />
                    <Route path="/auth/callback" element={<AuthCallback />} />
                    <Route path="/accept-invitation" element={<AcceptInvitation />} />
                    <Route path="/about" element={<AboutUs />} />
                    <Route path="/contact" element={<Contact />} />
                    <Route path="/blog" element={<Blog />} />
                    <Route path="/privacy" element={<PrivacyPolicy />} />
                    <Route path="/terms" element={<TermsOfService />} />
                    <Route path="/security" element={<Security />} />
                    
                    {/* Protected Routes */}
                    <Route path="/famlis" element={<ProtectedRoute><Famlis /></ProtectedRoute>} />
                    <Route path="/settings" element={<ProtectedRoute><FamilySettings /></ProtectedRoute>} />
                    <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
                    <Route path="/premium" element={<ProtectedRoute><Premium /></ProtectedRoute>} />
                    <Route path="/calendar" element={<ProtectedRoute><Calendar /></ProtectedRoute>} />
                    <Route path="/todolists" element={<ProtectedRoute><TodoLists /></ProtectedRoute>} />
                    <Route path="/secretsvault" element={<ProtectedRoute><SecretsVault /></ProtectedRoute>} />
                    <Route path="/documents" element={<ProtectedRoute><Documents /></ProtectedRoute>} />
                    <Route path="/appliances" element={<ProtectedRoute><Appliances /></ProtectedRoute>} />
                    <Route path="/vehicles" element={<ProtectedRoute><Vehicles /></ProtectedRoute>} />
                    <Route path="/familytree" element={<ProtectedRoute><FamilyTree /></ProtectedRoute>} />
                    <Route path="/healthwellness" element={<ProtectedRoute><HealthWellness /></ProtectedRoute>} />
                    <Route path="/trips" element={<ProtectedRoute><Trips /></ProtectedRoute>} />
                    <Route path="/beliefs" element={<ProtectedRoute><BeliefsAndTraditions /></ProtectedRoute>} />
                    <Route path="/community" element={<ProtectedRoute><CommunityAndGiving /></ProtectedRoute>} />
                    <Route path="/legacy" element={<ProtectedRoute><LegacyAndEstate /></ProtectedRoute>} />
                    <Route path="/pets" element={<ProtectedRoute><Pets /></ProtectedRoute>} />
                    <Route path="/recipes" element={<ProtectedRoute><RecipeBox /></ProtectedRoute>} />
                    <Route path="/finance" element={<ProtectedRoute><FamilyFinance /></ProtectedRoute>} />
                    <Route path="/contacts" element={<ProtectedRoute><ContactBook /></ProtectedRoute>} />
                    <Route path="/education" element={<ProtectedRoute><EducationLearning /></ProtectedRoute>} />
                </Routes>
            </div>
        </Router>
    );
}

export default App;


